<template>
    <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 7L0.468911 1.75L6.53109 1.75L3.5 7Z" fill="currentColor" />
    </svg>
</template>
